import React from "react";
import { Link } from "react-router-dom";
import errorImg from "../../assets/images/404.png";
import Layouts from "../helpers/Layouts";

export default function FourZeroFour() {
  return (
    <Layouts banner={false}>
      <section className="error-page text-center py-120 rpy-100">
        <div className="container">
          <div className="error-content">
            <img src={errorImg} alt="404 Error" />
            <h1>Oops! page not found.</h1>
            <p>We couldn't find the page you're looking for.</p>
            <Link to="/">
              <span className="theme-btn mt-30">go back</span>
            </Link>
          </div>
        </div>
      </section>
    </Layouts>
  );
}
